const key = 'pk_test_HiVfCOGJn7zayqtLZ06GUkKA';
const options = {};

export const stripeKey = key;
export const stripeOptions = options;
